import React, { useEffect } from 'react';

import logo from '../../assets/img/logo.png';
import Navbar from './Navbar/Navbar';
import contacts from './json/contact';

export interface IHeader {}

export default function Header(props: IHeader) {
  useEffect(() => {}, [window.innerWidth]);
  return (
    <header>
      <div className='bg-fr text-white px-3 py-2 flex flex-col lg:flex-row lg:justify-between items-center'>
        {contacts.data.map((contact, index) => {
          let windowWidth = window.innerWidth;
          let openTimesWidth = contacts.data[1].name.split(',');
          let arrayName = ['Opening Hours', 'Number'];
          let iconMTopAndBottom =
            contacts.data[index + 1]?.title === arrayName[index] ? 'mb-3' : '';
          return (
            <div className={`  ${iconMTopAndBottom}`} key={index}>
              {windowWidth < 450 && index === 1 ? (
                <>
                  <div className='flex  flex-col'>
                    <div className=''>
                      <span className={`${contact.icon} mr-3`}></span>
                      {openTimesWidth[0]}
                    </div>
                    <div className='pl-10'>{openTimesWidth[1]}</div>
                  </div>
                </>
              ) : (
                <>
                  <div className='flex flex-row'>
                    <div className={`${contact.icon} mr-3`}></div>
                    <div className=''>{contact.name}</div>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
      <div className='flex justify-center mt-5'>
        <div className='mx-5'>
          <img src={logo} alt='' />
        </div>
        <div className='mt-2 mx-4 block lg:hidden '>
          <i className='fas fa-bars text-fr fa-3x'></i>
        </div>
      </div>
      <div className=' flex justify-center'>
        <div className='text-white bg-sc lg:w-1/6 h-16 py-4 uppercase  min-GQ text-xl text-center mt-10 sm:w-2/6 w-5/6'>
          Get Instant Quote
        </div>
      </div>
      <div className='  hidden lg:flex   flex-col  items-center lg:flex-row justify-evenly lg:mt-10 '>
        <Navbar />
      </div>
    </header>
  );
}
